import { Item } from "../../../../services/monday/monday-query-interface";

const EXCLUDED_ITEM_IDS_PARAM = "excludedItemIds";

const normalizeItemIds = (itemIds: string[]): string[] =>
  Array.from(new Set(itemIds.map((itemId) => itemId.trim()).filter(Boolean)));

const parseItemIdParamValue = (value: string): string[] => {
  if (!value.trim()) return [];

  try {
    const parsedValue = JSON.parse(value);
    if (Array.isArray(parsedValue)) {
      return parsedValue.map((itemId) => String(itemId));
    }
  } catch {
    // Fall back to comma-separated values below.
  }

  return value.split(",");
};

export const parseExcludedItemIds = (search: string): string[] => {
  const searchParams = new URLSearchParams(search);
  const excludedItemIds = [
    ...searchParams.getAll(EXCLUDED_ITEM_IDS_PARAM),
    ...searchParams.getAll(`${EXCLUDED_ITEM_IDS_PARAM}[]`),
  ];

  return normalizeItemIds(excludedItemIds.flatMap(parseItemIdParamValue));
};

export const filterAvailableWizardItems = (
  items: Item[],
  excludedItemIds: string[],
): Item[] => {
  if (excludedItemIds.length === 0) return items;

  const excludedItemIdSet = new Set(excludedItemIds);
  return items.filter((item) => !excludedItemIdSet.has(String(item.id)));
};
